import React, { Fragment } from 'react';

import {
  Box,
  Button,
  Card,
  CircularProgress,
  Typography
} from '@material-ui/core';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Alert from '@material-ui/lab/Alert';

import AppSnackbar from '../../../common/AppSnackbar';
import CardContent from '../../../common/card/CardContent';
import CardTitle from '../../../common/card/CardTitle';
import { useSendInvite } from '../../../user/User.hooks';
import { User } from '../../../user/User.interface';

const UserInviteCard: React.FC<{ user: User }> = ({ user }) => {
  const { data: isSent, isLoading, error, post } = useSendInvite(user.id);

  return (
    <Card>
      <CardTitle>
        <MailOutlineIcon />
        Employee Invite
      </CardTitle>
      <CardContent padding='small'>
        {user ? (
          <Fragment>
            <Typography display='block' variant='caption'>
              Invite the user to access to the web portal. The user will receive
              an email with the invitation.
            </Typography>
            <Box mt={2}>
              {!isSent && user?.email && !user?.isPasswordSet ? (
                <Button
                  variant='outlined'
                  color='primary'
                  onClick={() => post()}
                  endIcon={
                    isLoading && <CircularProgress color='primary' size={20} />
                  }
                  disabled={isLoading}
                >
                  Send Invite
                </Button>
              ) : !user?.email ? (
                <Typography variant='subtitle2' color='error'>
                  Please fill in an email address for the user.
                </Typography>
              ) : isSent ? (
                <Alert severity='success'>Portal Invite Sent</Alert>
              ) : (
                user?.isPasswordSet && (
                  <Alert severity='success'>User has accepted</Alert>
                )
              )}
            </Box>
          </Fragment>
        ) : (
          <Box
            display='flex'
            alignItems='center'
            justifyContent='center'
            height={100}
          >
            <CircularProgress />
          </Box>
        )}
      </CardContent>
      <AppSnackbar severity='error' open={Boolean(error)}>
        There was an error sending the invite.
      </AppSnackbar>
    </Card>
  );
};

export default UserInviteCard;
